import { PlayIcon } from "@heroicons/react/24/solid";
import { CodeIcon } from "@heroicons/react/24/solid";
import { Link } from "react-router-dom";

const ProjectSubjects = [
  {
    title: "Swift",
    description:
      "Swift ist eine von Apple entwickelte Programmiersprache für iOS, macOS, watchOS und tvOS.",
    value: "swift",
    skill: {
      level: "Sehr gut",
      description:
        "Swift ist meine Lieblingssprache, sie ist simpel und logisch zu verstehen. Zudem mag ich, wie viel Abstraktion es gibt, sodass man wenig programmieren muss und Apple viel für einen übernimmt. Swift habe ich gelernt, indem ich den Online-Kurs von Code with Chris gemacht habe.",
      skills: ["Firebase", "Core Data", "MVVM", "SwiftUI", "Networking API"],
    },
    projects: [
      {
        title: "To-Do-Liste",
        description: "Eine einfache To-Do-Liste, die mit Swift erstellt wurde.",
        github: "https://github.com/JuliTheProgrammer/bankingApplication/tree/main",
        live: "https://appetize.io/app/i55iaj3lv57nevc5yqfaospyjm",
        image: "todolist",
      },
    ],
  },
  {
    title: "React",
    description:
      "React ist eine JavaScript-Bibliothek zur Entwicklung von Benutzeroberflächen.",
    value: "react",
    skill: {
      level: "Sehr gut",
      description: "Als ich HTML und CSS gelernt habe, wollte ich meine Websites dynamisch gestalten. Dies konnte ich mit einer JS-Bibliothek wie React machen. React habe ich mithilfe des Online-Kurses von Jonas Schmedtmann gelernt.",
      skills: ["React Router", "Redux", "Tailwind", "API Fetching"],
    },
    projects: [
      {
        title: "Redux Bank",
        description: "Verwalten Sie Ihre Finanzen in Echtzeit mit dieser Banking-App, die mit einer Real-Time-API verbunden ist.",
        image: "atm",
        github: "https://github.com/JuliTheProgrammer/redux-bank.git",
        live: "redux-bank-eta.vercel.app"
      },
      {
        title: "Far Away",
        description: "Gehen sie bald in die Ferien?",
        image: "palm",
        github: "https://github.com/JuliTheProgrammer/far-away.git",
        live: ""
      },
      {
        title: "usePopcorn",
        description: "Schauen Sie gerne Filme? Dann bewerten Sie Ihre Lieblingsfilme mit dieser App!",
        image: "movie",
        github: "https://github.com/JuliTheProgrammer/usePopcorn.git",
        live: "https://use-popcorn-inky.vercel.app/"
      },
    ],
  },
  {
    title: "Figma",
    description:
      "Figma ist ein webbasierter Grafikeditor, der von Teams zur Erstellung von Benutzeroberflächen verwendet wird.",
    value: "figma",
    skill: {
      level: "Gut",
      description: "Als XD nicht mehr die Funktionalität hatte, die ich brauchte, habe ich mich für Figma entschieden. Figma hat viel mehr Funktionalität als XD und ist zudem auch noch einfach zu benutzen.",
      skills: ["Prototyping", "Wireframing", "UI Design", "Components"],
    },
    projects: [
      {
        title: "Messaging-App",
        description:
          "Eine simple Messaging-App für iPhone. Das Design legt Wert auf eine intuitive und benutzerfreundliche Bedienung.",
        image: "socialMedia",
        live: "https://www.figma.com/design/DFLEnxw8XpB8CeQaqRuple/Messaging-App?node-id=0-1&t=0PRNxfpVYZWNOJkF-1",
      },
    ],
  },
  {
    title: "XD",
    description:
      "Adobe XD ist ein Vektor-basiertes Design-Tool für Benutzeroberflächen und Prototypen.",
    value: "xd",
    skill: {
      level: "Gut",
      description: "XD ist eine einfach zu bedienende UI/UX-Software, die ich verwenden wollte, um meine Ideen zu visualisieren.",
      skills: ["Prototyping"],
    },
    projects: [
      {
        title: "Online-Shop",
        description: "Wenn Sie Gourmet-Popcorn mögen, ist das der richtige Shop für Sie.",
        live: "https://xd.adobe.com/view/fafd2e5a-e133-4249-85da-22f68865b92a-afae/?fullscreen",
        image: "popcorn",
      },
      {
        title: "Wetter-App",
        description: "Eine moderne Wetter-App, die mit Adobe XD erstellt wurde.",
        live: "https://xd.adobe.com/view/21a08a8b-15d2-4aaf-8c6d-7bc2bb0ab9f7-74f3/?fullscreen",
        image: "weather",
      },
    ],
  },
  {
    title: "Java",
    description:
      "Java ist eine Programmiersprache, die auf der Java Virtual Machine (JVM) ausgeführt wird.",
    value: "java",
    skill: {
      level: "Sehr gut",
      description:
        "Java ist eine meiner Lieblingssprachen, es geht sehr viel um OOP. Das erste Mal, als ich davon gehört habe, hatte ich keine Ahnung, jedoch mithilfe des Online-Kurses von Tim habe ich das Konzept gut verstanden.",
      skills: ["OOP"],
    },
    projects: [
      {
        title: "Smart Kitchen",
        description: "Eine smarte Küche, die mithilfe von OOP operiert wird.",
        github: "https://github.com/JuliTheProgrammer/SmartKitchen.git",
        image: "kitchen",
      },
    ],
  },
  {
    title: "Lightroom",
    description:
      "Lightroom ist eine Bildbearbeitungssoftware, die von Adobe entwickelt wurde.",
    value: "lightroom",
    skill: {
      level: "Beginner",
      description:
        "Lightroom ist simpel, deshalb mag ich es. Mit Lightroom kann man sehr schnell und ohne viel Vorwissen gute Bilder bearbeiten. Ich habe dies in einem Online-Kurs bei bringyourownlaptop.com gelernt.",
      skills: ["Color Correction"],
    },
    projects: [
      {
        title: "Foto-Museum",
        description: "Eine Fotogalerie mit den bestbearbeiteten Fotos.",
        live: "https://lightroom.adobe.com/shares/9fda7bcab495480792834bdf853eaaf3",
        image: "museum",
      },
    ],
  },
];


export default function ProjectsPage() {
  return (
    <>
      <Link className="top-40" to="/">
        <div className="top-5 ml-40 pt-10">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="white"
            class="size-6"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="m11.25 9-3 3m0 0 3 3m-3-3h7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
            />
          </svg>
        </div>
      </Link>
      <div className="m-auto  max-w-max mt-6 text-center">
        <h3 className="text-gray-300 text-xl font-bold  uppercase tracking-wide">
          Projekte & Fähigkeiten
        </h3>
        <p className="text-gray-300 text-sx max-w-screen-md mt-8">
          Entdecken Sie meine Softwareprojekte, die meine Leidenschaft für die
          Entwicklung widerspiegeln. Für jedes Projekt finden Sie eine Live-Demo
          oder den Quellcode auf GitHub sowie eine Selbsteinschätzung meiner
          Kenntnisse in den verwendeten Technologien.
        </p>
      </div>
      <div className=" mt-52  ml-12 mr-12">
        {ProjectSubjects.map((subject) => (
          <div
            className=" p-10 border-2 border-zinc-50/50 rounded-md mt-14"
            key={subject.id}
          >
            <h4 className="text-gray-300 text-xl font-bold uppercase tracking-wide ">
              {subject.title}
            </h4>
            <p className="text-gray-300 text-xl mt-4">{subject.description}</p>
            <div>
              <div className=" grid grid-cols-4  mt-11">
                {subject.projects.map((project) => (
                  <div
                    key={project.id}
                    className="flex flex-row gap-1 rounded-md bg-gray-800 p-2 h-[223px] w-[358px] border-2 border-gray-900/50"
                  >
                    <div className=" w-fit">
                      <img
                        className="h-full object-cover rounded-md"
                        src={`./${project.image}.jpg`}
                        alt={project.title}
                      ></img>
                    </div>
                    <div className="flex p-1 flex-col">
                      <h5 className=" text-white text-xl font-bold uppercase tracking-wide mt-5">
                        {project.title}
                      </h5>
                      <p className="text-white text-xs mt-4">
                        {project.description}
                      </p>
                      <div className="mt-4 flex gap-3">
                        {project.github && (
                          <a
                            href={project.github}
                            target="."
                            className="flex flex-row gap-1 justify-between border-zinc-100 border-2 p-2 rounded-lg items-center"
                          >
                            <p className="text-white text-xs">Github</p>

                            <div>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                class="size-6"
                                color="white"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  d="M14.25 9.75 16.5 12l-2.25 2.25m-4.5 0L7.5 12l2.25-2.25M6 20.25h12A2.25 2.25 0 0 0 20.25 18V6A2.25 2.25 0 0 0 18 3.75H6A2.25 2.25 0 0 0 3.75 6v12A2.25 2.25 0 0 0 6 20.25Z"
                                />
                              </svg>
                            </div>
                          </a>
                        )}

                        {project.live && (
                          <a
                            href={project.live}
                            target="."
                            className="flex flex-row gap-1 justify-between border-zinc-100 border-2 p-2 rounded-lg items-center"
                          >
                            <p className="text-white text-xs">Live</p>
                            <div>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                class="size-6"
                                color="white"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.347a1.125 1.125 0 0 1 0 1.972l-11.54 6.347a1.125 1.125 0 0 1-1.667-.986V5.653Z"
                                />
                              </svg>
                            </div>
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
                <div className="bg-white border-2 rounded-lg col-start-4 p-12">
                  <div>
                    <span className="text-3xl font-extrabold tracking-wide bg-clip-text text-transparent bg-gradient-to-r from-pink-500 to-violet-500">
                      {subject.skill?.level}
                    </span>
                  </div>
                  <div>
                    <p className=" text-xs text-gray-800 mt-3">
                      {subject.skill?.description}
                    </p>
                  </div>
                  <div className="flex gap-2">
                    {subject.skill?.skills?.map((skill) => (
                      <div className="flex border-gray-200 rounded-lg mt-3">
                        <p className="text-gray-800 text-xs">{skill}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
